module.exports = __webpack_public_path__ + "img/createNewpro.ee824201.svg";